import { render } from "./DesignNavBar.vue?vue&type=template&id=6674dc77&scoped=true"
import script from "./DesignNavBar.vue?vue&type=script&lang=js"
export * from "./DesignNavBar.vue?vue&type=script&lang=js"

import "./DesignNavBar.vue?vue&type=style&index=0&id=6674dc77&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6674dc77"]])

export default __exports__